import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { useFetchData } from "../../../helpers/GlobalHelper";

const LmsSalesTeamNationalSalesManager = () => {
  const [{ data = { enableNotificationBypass: false } }] = useFetchData(
    "salesteam/national-sales-manager"
  );

  const myForm = new BCFormController(data, { values: data });

  myForm.addCenteredGroup([
    myForm.getDropdownField("National Sales Manager", "salesteam/list-national-sales-manager", {
      name: "organizationContactId",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Enable Notification Bypass", {
      name: "enableNotificationBypass",
      field: "checkbox",
      inline: true,
    }),
  ]);

  myForm.addCenteredGroup(
    [
      myForm.getDropdownField("Bypass Recipient", "salesteam/list-bypass-recipient", {
        name: "bypassOrganizationContactId",
      }),
    ],
    { isHiddenFunc: ({ inputs }) => inputs.enableNotificationBypass }
  );

  myForm.addCenteredGroup(
    [
      myForm.getDropdownField("Bypass Recipient", "salesteam/list-bypass-recipient", {
        name: "bypassOrganizationContactId",
        required: true,
      }),
    ],
    { isHiddenFunc: ({ inputs }) => !inputs.enableNotificationBypass }
  );

  const handleSubmit = (data, options) => {
    const { enableNotificationBypass, organizationContactId, bypassOrganizationContactId } = data;
    if (enableNotificationBypass && organizationContactId === bypassOrganizationContactId) {
      options.setFormErrorMessage({
        title: "Validation Errors",
        message: "National Sales Manager & Bypass Recipient cannot be same.",
      });
    } else {
      options.handleSubmit("salesteam", {
        data,
        method: "PUT",
        buttonText: options.buttonText,
      });
    }
  };

  return (
    <>
      <LmsFormGenerator
        myForm={myForm}
        handleSubmit={handleSubmit}
        actions={["save-close", "close"]}
      />
    </>
  );
};

export default LmsSalesTeamNationalSalesManager;
